import { useContext } from "react";
import { UserContext } from "src/context";

type UseRoleForBorrowerProps = () => "BORROWER" | "COBORROWER" | undefined;
export const useRoleForBorrower: UseRoleForBorrowerProps = () => {
  const { userData } = useContext(UserContext);
  if (userData?.borrower_id === userData?.roles?.borrower) {
    return "BORROWER";
  } else if (
    userData?.roles?.coborrowers?.includes(userData?.borrower_id ?? "")
  ) {
    return "COBORROWER";
  } else {
    return;
  }
};
